import { createFileRoute, redirect } from "@tanstack/react-router";

// 301 redirect: legacy WordPress URL -> current canonical page
export const Route = createFileRoute("/it-support-claremont-ca")({
  beforeLoad: () => {
    throw redirect({ href: "/articles/it-support-claremont-ca", statusCode: 301 });
  },
});
